import {
  ensureFreshAccessToken,
  readStoredAccessToken,
} from "features/auth/tokenRefresh";
import { useAppDispatch, useAppSelector } from "features/store";
import { botsManagementWs } from "features/ws/botsManagementWs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function BotsManagementWsConnector() {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const dispatch = useAppDispatch();

  // includes, not startsWith: the page is also mounted under
  // /client-view/:userId, where the socket is needed just the same.
  const onBotsManagement = location.pathname.includes("/bots-management");

  useEffect(() => {
    botsManagementWs.setTokenProvider(() => localStorage.getItem("accessToken"));
    return () => {
      botsManagementWs.setTokenProvider(null);
    };
  }, []);

  useEffect(() => {
    const unsubscribe = botsManagementWs.subscribeAuthRejected(() => {
      // The token the socket was refused with. Reconnecting on the same string
      // would just be refused again, so a reconnect needs a different one.
      const rejected = readStoredAccessToken();
      void ensureFreshAccessToken(dispatch).then(() => {
        const current = readStoredAccessToken();
        if (current && current !== rejected) {
          botsManagementWs.connect(current);
        }
      });
    });
    return unsubscribe;
  }, [dispatch]);

  useEffect(() => {
    if (!isAuthenticated || !accessToken || !onBotsManagement) {
      botsManagementWs.disconnect();
      return;
    }
    botsManagementWs.connect(accessToken);
  }, [isAuthenticated, accessToken, onBotsManagement]);

  return null;
}

export default BotsManagementWsConnector;
